<template>
  <transition name="pd-sku-sheet">
    <div
      v-if="open"
      class="pd-sku-drawer-root"
    >
    <div
      class="pd-sku-drawer-backdrop"
      @click="$emit('close')"
    />
    <div
      class="pd-sku-drawer"
      role="dialog"
      aria-modal="true"
    >
      <div class="pd-sku-drawer__head">
        <div class="pd-sku-drawer__product">
          <button
            type="button"
            class="pd-sku-drawer__thumb-btn"
            :aria-label="$t('pdViewImage')"
            @click="$emit('preview')"
          >
            <img
              v-if="thumb"
              :src="thumb"
              alt=""
              class="pd-sku-drawer__thumb"
            >
            <span
              class="pd-sku-drawer__thumb-zoom"
              aria-hidden="true"
            >
              <i class="fal fa-search-plus" />
            </span>
          </button>
          <div class="pd-sku-drawer__prices">
            <span class="pd-sku-drawer__thb">฿{{ unitThb || thb }}</span>
            <span
              v-if="unitCny || cny"
              class="pd-sku-drawer__cny"
            >¥{{ unitCny || cny }}</span>
            <span
              v-if="skuLabel"
              class="pd-sku-drawer__sku"
            >{{ skuLabel }}</span>
            <span
              v-else
              class="pd-sku-drawer__sku-muted"
            >{{ $t('pdPickOptions') }}</span>
          </div>
        </div>
        <button
          type="button"
          class="pd-sku-drawer__close"
          :aria-label="$t('cancel')"
          @click="$emit('close')"
        >
          <i class="fal fa-times" />
        </button>
      </div>

      <div class="pd-sku-drawer__body">
        <pd-sku-picker
          variant="drawer"
          v-bind="picker"
          @pick-color="$emit('pick-color', $event)"
          @pick-size="$emit('pick-size', $event)"
          @select-sku="$emit('select-sku', $event)"
          @set-qty="$emit('set-qty', $event)"
        />

        <div
          class="pd-sku-note"
          :class="{ 'is-disabled': !ready }"
        >
          <div class="pd-sku-note__label">
            {{ $t('pdAttachModalTitle') }}
            <span
              v-if="skuLabel"
              class="pd-sku-note__target"
            >
              <img
                v-if="thumb"
                :src="thumb"
                alt=""
                class="pd-sku-note__target-img"
              >
              <span class="pd-sku-note__target-text">{{ skuLabel }}</span>
            </span>
            <span
              v-else
              class="pd-sku-note__target-muted"
            >{{ $t('pdPickOptions') }}</span>
          </div>
          <div class="pd-sku-note__row">
            <div
              v-if="fileimg"
              class="pd-sku-note__preview"
            >
              <img
                :src="fileimg"
                alt=""
              >
              <button
                type="button"
                class="pd-sku-note__remove"
                :aria-label="$t('cancel')"
                @click="$emit('clear-file')"
              >
                <i class="fal fa-times" />
              </button>
            </div>
            <label
              v-else
              class="pd-sku-note__pick"
            >
              <i class="fal fa-plus" />
              <span>{{ $t('attachedFile') }}</span>
              <input
                type="file"
                accept="image/*"
                :disabled="!ready"
                @change="onPickFile"
              >
            </label>
            <textarea
              :value="remark"
              class="pd-sku-note__text"
              rows="3"
              :placeholder="$t('remarks')"
              :disabled="!ready"
              @input="$emit('set-remark', $event.target.value)"
            />
          </div>
          <div
            v-if="!ready"
            class="pd-sku-hint pd-sku-note__hint"
          >
            {{ $t('pdCompleteSelectionHint') }}
          </div>
        </div>
      </div>

      <div class="pd-sku-drawer__footer">
        <button
          type="button"
          class="pd-sku-drawer__confirm"
          :disabled="!ready"
          @click="$emit('confirm')"
        >
          <span class="pd-sku-drawer__confirm-label">{{ $t('pdAddToCartEnter') }}</span>
          <span class="pd-sku-drawer__confirm-prices">
            <span class="pd-sku-drawer__confirm-price">฿{{ thb }}</span>
            <span
              v-if="cny"
              class="pd-sku-drawer__confirm-cny"
            >¥{{ cny }}</span>
          </span>
        </button>
      </div>
    </div>
    </div>
  </transition>
</template>

<script>
import PdSkuPicker from './PdSkuPicker.vue'

export default {
  name: 'PdSkuDrawer',
  components: { PdSkuPicker },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    thumb: {
      type: String,
      default: '',
    },
    thb: {
      type: String,
      default: '0',
    },
    cny: {
      type: String,
      default: '',
    },
    unitThb: {
      type: String,
      default: '',
    },
    unitCny: {
      type: String,
      default: '',
    },
    skuLabel: {
      type: String,
      default: '',
    },
    ready: {
      type: Boolean,
      default: false,
    },
    picker: {
      type: Object,
      default: () => ({}),
    },
    remark: {
      type: String,
      default: '',
    },
    fileimg: {
      type: String,
      default: '',
    },
  },
  methods: {
    onPickFile(e) {
      const file = e.target.files && e.target.files[0]
      if (file) this.$emit('set-file', file)
      e.target.value = ''
    },
  },
}
</script>
